import { Component } from '@verndale/core';
import Swiper from 'swiper/js/swiper';
import { breakpoints } from '../utils/breakpoints';

class Module extends Component {
  setupDefaults() {
    this.dom = {
      $el: this.el,
      $slider: this.el._$('.swiper-container'),
      $slides: this.el._$$('.featured-items-carousel__card'),
      $pagination: this.el._$('.featured-items-carousel__pagination')
    };
    this.swiper = null;
    this.loop = false;
    this.minSlides = 3;

    this.hidePagination();
    this.initSlider();
    this.applyWistiaClass();
  } //setupDefaults

  hidePagination() {
    const { $slides, $pagination } = this.dom;
    const slidesCount = $slides?.length || 0;

    if (slidesCount > this.minSlides) {
      this.loop = true;
      $pagination.classList.add('featured-items-carousel__pagination--visible');
    }
  } //hidePagination

  initSlider() {
    const { $slider, $el } = this.dom;
    const getPaginationType = $el.getAttribute('data-pagination-type');
    const paginationType =
      getPaginationType === 'numbers' ? 'fraction' : 'bullets';

    this.swiper = new Swiper($slider, {
      //Basic
      loop: this.loop,
      slidesPerView: 'auto',
      spaceBetween: 14,
      watchOverflow: true,

      //Pagination
      pagination: {
        el: '.swiper-pagination',
        type: paginationType,
        clickable: true
      },

      //Navigation
      navigation: {
        nextEl: '.swiper-arrow-next',
        prevEl: '.swiper-arrow-prev'
      },

      //Breakpoints
      breakpoints: {
        // when window width is >= 1200px
        [breakpoints.tabletLandscapeLimit]: {
          slidesPerView: 3,
          slidesPerGroup: 3,
          spaceBetween: 35,
          loopFillGroupWithBlank: true
        }
      }
    });
  } //initSlider

  applyWistiaClass() {
    const { $slides } = this.dom;

    $slides.forEach(item => {
      const description = item.querySelector('.featured-items-carousel__card-description');

      const wistiaSpan = description.querySelector('.wistia_embed');

      if (wistiaSpan) {
        const videoIdMatch = wistiaSpan.className.match(/wistia_async_([a-z0-9]+)/);

        if (videoIdMatch) {
          const videoId = videoIdMatch[1];
          const imageElement = item.querySelector('.wistia_embed');

          if (imageElement) {
            imageElement.classList.add(`wistia_async_${videoId}`);
          }
        }
      }
    });
  }  //applyWistiaClass

}

export default Module;
